"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Image = void 0;
var _react = _interopRequireDefault(require("react"));
var _badge = require("@oneloop/badge");
var _box = require("@oneloop/box");
var _icons = require("@oneloop/icons");
var _hooks = require("@oneloop/hooks");
var _excluded = ["textBadge", "variant", "variantBadge", "icon", "iconColor"];
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
var Image = exports.Image = function Image(_ref) {
  var textBadge = _ref.textBadge,
    variant = _ref.variant,
    _ref$variantBadge = _ref.variantBadge,
    variantBadge = _ref$variantBadge === void 0 ? 'badgeInfoRow' : _ref$variantBadge,
    icon = _ref.icon,
    _ref$iconColor = _ref.iconColor,
    iconColor = _ref$iconColor === void 0 ? '#AEBAC0' : _ref$iconColor,
    props = _objectWithoutProperties(_ref, _excluded);
  var _useToggle = (0, _hooks.useToggle)(false),
    _useToggle2 = _slicedToArray(_useToggle, 2),
    error = _useToggle2[0],
    setError = _useToggle2[1];
  return /*#__PURE__*/_react["default"].createElement(_box.Box, _extends({
    onError: function onError() {
      return setError(true);
    },
    variant: variant
  }, props, {
    __css: {
      maxWidth: '100%',
      height: 'auto',
      position: 'relative',
      textAlign: 'center',
      background: error && '#EFF3F5'
    }
  }), /*#__PURE__*/_react["default"].createElement(_box.Box, _extends({
    as: "img",
    display: error ? 'none' : 'normal',
    variant: variant
  }, props, {
    __css: {
      maxWidth: '100%',
      height: 'auto',
      alignItems: 'center',
      justifyContent: 'center'
    }
  })), icon && error && /*#__PURE__*/_react["default"].createElement(_icons.Icon, {
    icon: icon,
    fontSize: variant === 'avatar' ? '32px' : '24px',
    style: {
      color: iconColor,
      position: 'absolute',
      top: variant === 'avatar' ? '0px' : '12px',
      left: variant === 'avatar' ? '0px' : '24px'
    }
  }), textBadge && /*#__PURE__*/_react["default"].createElement(_badge.Badge, {
    variant: variantBadge,
    style: {
      position: 'absolute',
      left: '0px',
      bottom: '-1px',
      width: '100%',
      textTransform: 'none'
    }
  }, textBadge));
};